module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc2"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/cover"
    }
  }, [_vm._v("Dorothy and the Wizard in Oz")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/WizardinOz2#_idParaDest-1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/Epigraph"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/WizardinOz3#_idParaDest-2"
    }
  }, [_vm._v("To My Readers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/WizardinOz4#_idParaDest-3"
    }
  }, [_vm._v("The Earthquake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/WizardinOz5#_idParaDest-4"
    }
  }, [_vm._v("The Glass City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/WizardinOz6#_idParaDest-5"
    }
  }, [_vm._v("The Arrival of The Wizard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/WizardinOz7#_idParaDest-6"
    }
  }, [_vm._v("The Vegetable Kingdom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/WizardinOz8#_idParaDest-7"
    }
  }, [_vm._v("Dorothy Picks the Princess")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/WizardinOz9#_idParaDest-8"
    }
  }, [_vm._v("The Mangaboos Prove Dangerous")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/WizardinOz10#_idParaDest-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Into the Black Pit and Out Again")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/WizardinOz11#_idParaDest-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Valley of Voices")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/WizardinOz12#_idParaDest-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They Fight the Invisible Bears")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/WizardinOz13#_idParaDest-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Braided Man of Pyramid Mountain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/WizardinOz14#_idParaDest-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("They Meet the Wooden Gargoyles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/WizardinOz15#_idParaDest-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Wonderful Escape")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/WizardinOz16#_idParaDest-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Den of the Dragonettes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/WizardinOz17#_idParaDest-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ozma Uses the Magic Belt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/WizardinOz18#_idParaDest-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Friends Are Reunited")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/WizardinOz19#_idParaDest-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jim, the Cab-Horse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/WizardinOz20#_idParaDest-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nine Tiny Piglets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/WizardinOz21#_idParaDest-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Trial of Eureka the Kitten")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/WizardinOz22#_idParaDest-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wizard Performs Another Trick")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/WizardinOz23#_idParaDest-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zeb Returns to the Ranch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/Preview",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preview: The Road to Oz")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Road to OZ")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz#_idParaDest-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz1#_idParaDest-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To My Readers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz2#_idParaDest-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Way to Butterfield")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz3#_idParaDest-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dorothy Meets Button-Bright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz4#_idParaDest-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Queer Village")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz5#_idParaDest-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("King Dox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz6#_idParaDest-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rainbow’s Daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz7#_idParaDest-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The City of Beasts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz8#_idParaDest-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Shaggy Man’s Transformation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz9#_idParaDest-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Musicker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz10#_idParaDest-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Facing the Scoodlers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz11#_idParaDest-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Escaping the Soup-Kettle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz12#_idParaDest-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Johnny Dooit Does It")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz13#_idParaDest-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Deadly Desert Crossed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz14#_idParaDest-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Truth Pond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz15#_idParaDest-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tik-Tok and Billina")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz16#_idParaDest-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Emperor’s Tin Castle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz17#_idParaDest-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visiting the Pumpkin-Field")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz18#_idParaDest-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Royal Chariot Arrives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz19#_idParaDest-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Emerald City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz20#_idParaDest-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Shaggy Man’s Welcome")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz21#_idParaDest-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Princess Ozma of Oz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz22#_idParaDest-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dorothy Receives the Guests")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz23#_idParaDest-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Important Arrivals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz24#_idParaDest-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Grand Banquet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/RoadtoOz25#_idParaDest-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Birthday Celebration")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/00_Cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Emerald City of Oz")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/02_Title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/05_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Nome King Became Angry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/06_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Uncle Henry Got Into Trouble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/07_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Ozma Granted Dorothy’s Request")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/08_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Nome King Planned Revenge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/09_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Dorothy Became a Princess")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/10_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Guph Visited the Whimsies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/11_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Aunt Em Conquered the Lion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/12_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Grand Gallipoot Joined the Nomes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/13_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Wogglebug Taught Athletics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/14_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Cuttenclips Lived")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/15_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the General Met the First and Foremost")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/16_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How They Matched the Fuddles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/17_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the General Talked to the King")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/18_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Wizard Practiced Sorcery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/19_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Dorothy Happened to Get Lost")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/20_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Dorothy Visited Utensia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/21_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How They Came to Bunbury")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/22_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Ozma Looked Into the Magic Picture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/23_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Bunnybury Welcomed the Strangers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/24_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Dorothy Lunched With a King")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/25_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the King Changed His Mind")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/26_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Wizard Found Dorothy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/27_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How They Encountered the Flutterbudgets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/28_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Tin Woodman Told the Sad News")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/29_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Scarecrow Displayed His Wisdom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/30_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Ozma Refused to Fight for her Kingdom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/31_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Fierce Warriors Invaded Oz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/32_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How They Drank at the Forbidden Fountain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/33_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Glinda Worked a Magic Spell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/34_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How the Story of Oz Came to an End")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc27d5a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bundle_content.vue
// module id = 60
// module chunks = 0